import { TypedDocumentNode, gql } from '@apollo/client';

type QueryVariables = {
  id: number;
};

export type GetErpSystemType = {
  orders_companies_by_pk: {
    erp_system: string | null;
  };
};

export const getErpSystemQuery = gql`
  query getErpSystem($id: bigint!) {
    orders_companies_by_pk(id: $id) {
      id
      erp_system
    }
  }
` as TypedDocumentNode<GetErpSystemType, QueryVariables>;
